function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSocialX = function SvgSocialX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m106.69 96.59 45.01 64.38h-18.47L96.5 108.44l-5.39-7.71-42.9-61.37h18.47l34.62 49.53 5.39 7.71Z",
    style: {
      fill: "#1b053a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.39 0H21.61C9.68 0 0 9.68 0 21.61v156.78C0 190.32 9.68 200 21.61 200h156.78c11.93 0 21.61-9.68 21.61-21.61V21.61C200 9.68 190.32 0 178.39 0m-50.82 169.6L90.4 115.51 43.87 169.6H31.84l53.22-61.86-53.22-77.45h40.59l35.19 51.22 44.06-51.22h12.03l-50.75 58.99 55.19 80.32h-40.59Z",
    style: {
      fill: "#1b053a",
      strokeWidth: 0
    }
  }));
};
export default SvgSocialX;